export const constructionSiteReceptionQueryKeys = {
	all: ["construction-site-reception"] as const,
	details: () =>
		[...constructionSiteReceptionQueryKeys.all, "details"] as const,
	detail: (constructionSiteId: number) =>
		[
			...constructionSiteReceptionQueryKeys.details(),
			constructionSiteId,
		] as const,
	folder: (constructionSiteId: number) =>
		[
			...constructionSiteReceptionQueryKeys.detail(constructionSiteId),
			"folder",
		] as const,
};
